import { validateAssetManifest } from './AssetManifestValidator';
import type { AssetId, AssetManifestEntry, PreloadPolicy } from './AssetTypes';

/** Read-only lookup over the asset manifest. No rendering dependencies. */
export class AssetRegistry {
  private readonly byId = new Map<AssetId, AssetManifestEntry>();

  constructor(entries: readonly AssetManifestEntry[]) {
    const errors = validateAssetManifest(entries);
    if (errors.length > 0) throw new Error(`Invalid asset manifest:\n${errors.join('\n')}`);
    for (const entry of entries) this.byId.set(entry.id, entry);
  }

  has(id: AssetId): boolean {
    return this.byId.has(id);
  }

  get(id: AssetId): AssetManifestEntry {
    const entry = this.byId.get(id);
    if (!entry) throw new Error(`Unknown asset id ${id} – add it to assetManifest.ts`);
    return entry;
  }

  all(): readonly AssetManifestEntry[] {
    return [...this.byId.values()];
  }

  withPreload(...policies: PreloadPolicy[]): readonly AssetManifestEntry[] {
    return this.all().filter((entry) => policies.includes(entry.preload));
  }
}
